import { ReactNode } from 'react';
import styles from './main-menu-icon.module.css';

interface Props {
  menuItemIcon: ReactNode;
}

const MainMenuIcon = ({ menuItemIcon }: Props): JSX.Element => {
  return <div className={styles.icon}>{menuItemIcon}</div>;
};

export default MainMenuIcon;
